import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';

export const SummaryWrapper = styled.div`
  background: ${colors.secondary[50]};
`;

export const Summary = styled.div`
  padding: ${spacing.space32};
`;

export const SummaryHeading = styled(Text)`
  font-size: 1.375rem;
  margin-top: 0;
  margin-bottom: 0;
`;

export const LineGroup = styled.div`
  margin-top: ${spacing.space32};
`;

export const LineWrapper = styled.div<{ $withTopBorder?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-top: ${({ $withTopBorder }) => ($withTopBorder ? '1px solid rgba(10, 10, 10, 0.12)' : undefined)};
  margin-top: ${({ $withTopBorder }) => ($withTopBorder ? spacing.space32 : '0')};
  padding-top: ${({ $withTopBorder }) => ($withTopBorder ? spacing.space32 : '0')};
`;

export const LineText = styled(Text)`
  margin: 0;
`;

export const DetailText = styled(Text)`
  margin: 0;
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing.space16};
  margin-top: ${spacing.space8};
`;

export const DetailPrice = styled(Text)`
  margin: 0;
  min-width: 70px;
  text-align: right;
`;

export const Price = styled(Text)`
  margin: 0;
  min-width: 70px;
  text-align: right;
`;

export const TotalPrice = styled(Text)`
  margin: 0;
`;

export const MemberText = styled.span`
  font-size: 1.125rem;
  font-weight: 400;
`;
